import { ITag } from "@fluentui/react";

export const sortTerms = (input: string, data: ITag[]): ITag[] => {
    try {
        let first: ITag[] = [];
        let others: ITag[] = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].name.indexOf(input) == 0) {
                first.push(data[i]);
            } else {
                others.push(data[i]);
            }
        }
        first.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
        others.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
        return (first.concat(others));
    } catch (error) {
        console.warn(error);
    }
    return data;
}